import { TelecollectionQueryService } from "../../../services/payments/TelecollectionQueryService";
import { TelecollectionModel } from "../../models/Telecollection";
import { IQueryTelecollectionRepository } from "../../ports/payments/IQueryTelecollectionRepository";
import Query from "../Query";

class TelecollectionQuery
  extends Query<TelecollectionModel>
  implements IQueryTelecollectionRepository
{
  constructor(public queryService: TelecollectionQueryService) {
    super(queryService);
  }
}

export default TelecollectionQuery;
